import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from './styles.css';
import messages from './messages';
import DefListColumn from '../DefListColumn';

const TransferPanelPayPal = ({ relationshipId, status, establishedDate }) => (
  <div className={styles.rightPane}>
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.relationshipId} />}
      data={relationshipId}
      dataTestHandle="journalDetails__relationshipId"
    />
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.status} />}
      data={status}
      dataTestHandle="journalDetails__status"
    />
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.establishedDate} />}
      data={establishedDate}
      dataTestHandle="journalDetails__establishedDate"
    />
  </div>
);

TransferPanelPayPal.propTypes = {
  relationshipId: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  establishedDate: PropTypes.string.isRequired,
};

export default TransferPanelPayPal;



// WEBPACK FOOTER //
// ./src/components/TransferPanelPayPal/index.js